import { html, repeat, when } from '@microsoft/fast-element';
import { warningIcon } from '../../../styles';
import type { ErrorUploadGrid } from './error-upload-grid';

export const ErrorUploadGridTemplate = html<ErrorUploadGrid>`
  <table>
    <tr class="table-title-container">
      <th class="table-title warning-col"></th>
      ${repeat(
        (x, y) => x.errorProject.fields,
        html`
          ${when(
            (x) => x.fieldHasProblem || x.fieldName === 'NAME' || x.fieldName === 'TICKER',
            html`
              <th class=" table-title">${(x) => (x.headerName ? x.headerName : x.fieldName)}</th>
            `
          )}
        `
      )}
    </tr>
    <tr class="table-value-container">
      <td class="table-value warning-col">
        <div class="warning-icon">${warningIcon}</div>
      </td>
      ${repeat(
        (x) => x.errorProject.fields,
        html`
          ${when(
            (x) => x.fieldHasProblem || x.fieldName === 'NAME' || x.fieldName === 'TICKER',
            html`
              <td class="error-value table-value">
                <div
                  class=" ${(x) =>
                    x.fieldName === 'NAME' || x.fieldName === 'TICKER' ? 'name-col' : ''} main-text"
                >
                  ${(x) => x.fieldValue}
                </div>
                ${when(
                  (x) => x.errorMessage,
                  html`
                    <span class="hover-error">${(x) => x.errorMessage}</span>
                  `
                )}
              </td>
            `
          )}
        `
      )}
    </tr>
  </table>
`;
